var map = {
	"./CSV_exampleImage.jpg": 533,
	"./Circle-white.svg": 1264,
	"./Circle-whitea.svg": 1265,
	"./Confluence_Domain_url.png": 534,
	"./Getting started page media/Check-ins onboarding illustrations/1 Locate Troopr Assistant in Slack.svg": 1266,
	"./Getting started page media/Check-ins onboarding illustrations/2. Submit 1st standup answer.svg": 535,
	"./Getting started page media/Check-ins onboarding illustrations/3. Integrate with Jira.svg": 536,
	"./Getting started page media/Check-ins onboarding illustrations/4. Share Jira context in reports.svg": 537,
	"./Getting started page media/Helpdesk onboarding Emoji/1. Success.svg": 350,
	"./Getting started page media/Helpdesk onboarding Emoji/2. Manage private requests.svg": 538,
	"./Getting started page media/Helpdesk onboarding Emoji/3. Hurray, you made it.svg": 1267,
	"./Getting started page media/Helpdesk onboarding Modal illustrations/1. Setup demo Helpdesk channels.svg": 539,
	"./Getting started page media/Helpdesk onboarding Modal illustrations/2. Check update in support channel.svg": 540,
	"./Getting started page media/Helpdesk onboarding Modal illustrations/3. In App Home.svg": 541,
	"./Getting started page media/Helpdesk onboarding Modal illustrations/4. In DM with agents.svg": 542,
	"./Getting started page media/Helpdesk onboarding Modal illustrations/5. Manage approvals.svg": 543,
	"./Getting started page media/Helpdesk onboarding Modal illustrations/6. Create approval request.svg": 544,
	"./Getting started page media/Helpdesk onboarding Modal illustrations/7. Get notified and take action.svg": 545,
	"./Getting started page media/Project onboarding illustration/1.Setup demo project channel.svg": 546,
	"./Getting started page media/Project onboarding illustration/2. Issue card.svg": 547,
	"./Getting started page media/wiki onboarding illustrations/1. Setup demo wiki channels.svg": 548,
	"./Getting started page media/wiki onboarding illustrations/2. Add to Confluence.svg": 549,
	"./Github_logo.png": 550,
	"./Home Tab/Active users.svg": 336,
	"./Home Tab/Channels with Troopr.svg": 337,
	"./Home Tab/Checkins.svg": 551,
	"./Home Tab/Helpdesk.svg": 552,
	"./Home Tab/Hey Sam, welcome to Troopr.svg": 1268,
	"./Home Tab/Projects.svg": 553,
	"./Home Tab/Verified Jira account.svg": 338,
	"./Home Tab/Wiki.svg": 554,
	"./Home Tab/Workflow activities.svg": 339,
	"./Home Tab/check-circle.svg": 555,
	"./Home Tab/reports.svg": 556,
	"./Home Tab/welcome_to_troopr_card.svg": 557,
	"./Jira_logo.png": 245,
	"./applicationLink2.PNG": 1269,
	"./applicationlink.png": 1270,
	"./arrow-shape.png": 1271,
	"./as-appsumo-logo-blk.png": 532,
	"./assign.svg": 1272,
	"./audio_icon.png": 1273,
	"./bitbucket.svg": 1274,
	"./chat_extraction.svg": 1275,
	"./chevron_down.svg": 1276,
	"./chevron_up.svg": 1277,
	"./circular_troopr_logo.svg": 207,
	"./consumer.png": 1278,
	"./cross.svg": 1279,
	"./cross_white.svg": 1280,
	"./download.svg": 1281,
	"./emptyTaskProgress.svg": 1282,
	"./file_text.png": 1283,
	"./filter-sidebar-assignee.svg": 1284,
	"./filter-sidebar-checkmark.svg": 1285,
	"./filter-sidebar-close.svg": 1286,
	"./filter-sidebar-unassigned.svg": 1287,
	"./gantt_placeholder.png": 1288,
	"./gitLab.png": 1289,
	"./google_icon.svg": 665,
	"./image_icon.png": 1290,
	"./jira_cloud_site_url_example.jpeg": 558,
	"./jira_final_notification_setup.jpeg": 1291,
	"./jira_intial_notification_setup.jpeg": 1292,
	"./jira_server_site_url_example.jpeg": 559,
	"./jira_transparent.png": 1293,
	"./jira_white_logo.svg": 1294,
	"./kanban.svg": 1295,
	"./list.svg": 1296,
	"./logo.svg": 1297,
	"./no_notif.svg": 1298,
	"./options.svg": 1299,
	"./plus.svg": 1300,
	"./projectReportEmpty.svg": 1301,
	"./purple_arrow.svg": 1302,
	"./sentry.svg": 1303,
	"./shape-copy-13.svg": 1304,
	"./shape.svg": 1305,
	"./shape3.svg": 1306,
	"./slack-1.svg": 664,
	"./slack_logo.png": 560,
	"./slacklo.png": 1307,
	"./tada.png": 1308,
	"./task-sidebar-followers-selected.svg": 1309,
	"./task-sidebar-marked.svg": 1310,
	"./task_checked.svg": 1311,
	"./task_unchecked.svg": 1312,
	"./troopr-jira-configure-app-link.png": 1313,
	"./troopr_guide.png": 1314,
	"./troopr_guide_7.svg": 1315,
	"./troopr_logo.png": 531,
	"./trooprlogo1.svg": 1316,
	"./undefined_icon.png": 1317,
	"./video_icon.png": 1318,
	"./webhook1.png": 1319,
	"./webhook2.png": 1320,
	"./zip_icon.png": 1321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1263;